import api from '../api'
export default {
	namespaced: true,
	state: {
		tourList: [],
		tourTotal: ''
	},
	mutations: {
		GET_TOUR_LIST( state, data = {} ) {
			state.tourList = data.records
			state.tourTotal = data.total
		}
	},
	actions: {
		GET_TOUR_LIST( { commit, dispatch },  config ) {
			return api.getTourList( config ).then(( res ) => {
				commit( 'GET_TOUR_LIST', res.payload )
				return res
			}).catch(( rej ) => {
				window.myVue.$message.error( rej.message )
			})
		},
		GET_TOUR_DETAIL ({ commit, dispatch }, config) {
			return api.tourDetail(config).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		},
		DELETE_TOUR ({ commit, dispatch }, params) {
			return api.deletetour({
				params: params
			}).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		},
		ADD_TOUR ({ commit, dispatch }, config) {
			return api.addtour(config).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		},
		UPDATE_TOUR ({ commit, dispatch }, config) {
			return api.updatetour(config).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		}
	}
}


// WEBPACK FOOTER //
// ./src/views/tourManage/store/index.js